export default __webpack_public_path__ + "static/media/group-626@3x.28cc6905.png";